import React from 'react';

import * as customPropTypes from '@/custom-prop-types';

import { useTermFinderContext } from '../../stores/termFinderStore';
import { Accordion } from '../Accordion';
import { SearchResults } from '../SearchResults';
import styles from './MainContent.module.scss';

export const MainContent = ({ analytics }) => {
    const mainContentState = useTermFinderContext((s) => s.state.mainContent);

    return (
        <div className={styles['term-finder__main-content']}>
            {mainContentState === 'accordion' && <Accordion analytics={analytics} />}
            {mainContentState === 'searchResults' && <SearchResults analytics={analytics} />}
        </div>
    );
};
MainContent.propTypes = {
    /**
     * analytics object
     */
    analytics: customPropTypes.analyticsPropType,
};
